export default __webpack_public_path__ + "static/sauce-ai-logo-4bfbbe3d10072af8f93472c9adc65687.png";